module.exports = "<div class=\"loader-content\">\n  <div class=\"app-loader\"></div>\n  {% if showText %}<div class=\"text\">{{text|e}}</div>{% endif %}\n</div>";
